<!--header-right-->
<template>
  <div class="home-auth-list-item" >
    <div class="home-auth-list-item-header">
      <span class="name">{{nameStr}}</span>
      <span class="look-details" @click="$emit('gotoDetails')">{{$t('Details_1')}}</span>
    </div>
    <div class="home-auth-list-item-cell">
      <div class="home-auth-list-item-cell-icon" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/icons_16pt_clock.svg')})`}"></div>
      <div class="home-auth-list-cell-text">{{dateStr}}</div>
    </div>
    <div class="home-auth-list-item-cell">
      <div class="home-auth-list-item-cell-icon" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/Union.svg')})`}"></div>
      <div class="home-auth-list-cell-text">{{CitiesStr || '--'}}</div>
    </div>
    <div class="home-auth-list-item-cell" style="margin-bottom: 12px">
      <div class="home-auth-list-item-cell-icon" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/icons_16pt_remark.svg')})`}"></div>
      <div class="home-auth-list-cell-text">{{details.Purpose || '--'}}</div>
    </div>
    <div class="home-auth-list-item-cell last-cell">
      <div class="business-item"
           v-if="(details.FlightInfo && details.FlightInfo.IsDisplayBookButton) ||
            (details.IntlFlightInfo && (details.IntlFlightInfo.IsDisplayBookButton || details.IntlFlightInfo.IsDisplayEnquiryButton))">
        <hs-business-icon :OrderBusinessType="1" />{{$t('FlightTicket')}}
      </div>
      <div class="business-item" v-if="(details.HotelInfo && details.HotelInfo.IsDisplayBookButton) || (details.IntlHotelInfo && details.IntlHotelInfo.IsDisplayBookButton)">
        <hs-business-icon :OrderBusinessType="2" />{{$t('Hotel')}}
      </div>
      <div class="business-item" v-if="details.TrainInfo && details.TrainInfo.IsDisplayBookButton">
        <hs-business-icon :OrderBusinessType="10" />{{$t('Train')}}
      </div>
      <div class="business-item" v-if="details.CarInfo && details.CarInfo.IsDisplayBookButton">
        <hs-business-icon :OrderBusinessType="14" />{{$t('Car')}}
      </div>
    </div>
    <div class="home-auth-list-footer">
      <div class="order-number"><span>{{getSetting('国内机票配置:正常订单:授权码名称')}}: {{details.Code}}</span></div>
      <hs-button class="btn" height="28px" :fontSize="null" :font-type="'S'" type="theme" @click="$emit('gotoBooking')">{{$t('Book_2')}}</hs-button>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import HsSectionHeader from "@/base/hs-tableview/hs-section-header.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import HsBusinessIcon from "@/base/hs-tableview/hs-icon/hs-business-icon.vue";
export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showAuthList: false,
    }
  },
  computed: {
    nameStr() {
      let nameStr = '--'
      let Passengers = this.details.Passengers || []
      nameStr = Passengers.map(v => v.Name).join(' | ')
      return nameStr
    },
    dateStr() {
      let {AuthStartTime, AuthEndTime} = this.details
      let date = '--'
      if (AuthStartTime && AuthEndTime) {
        AuthStartTime = this.$t(this.beTime(AuthStartTime), 'date', ['yyyy-MM-dd', 'MM dd, yyyy'])
        AuthEndTime = this.$t(this.beTime(AuthEndTime), 'date', ['yyyy-MM-dd', 'MM dd, yyyy'])
        date = this.$t('AToB_x_x', 'function', [AuthStartTime, AuthEndTime])
      }
      return date
    },
    CitiesStr() {
      let CitiesStr = '--'
      CitiesStr = (this.details.Cities || []).join(' | ')
      return CitiesStr
    }
  },
  methods: {
    _getBusinessName(OrderBusinessType) {
      // 机票预订 1 国际机票预订 6 酒店预订 2 海外酒店 11 火车票 10 用车 14 国际机票需求单 17
      if (OrderBusinessType === 1) {
        return this.$t('DomesticFlights')
      }

      if (OrderBusinessType === 6) {
        return this.$t('IntlFlights')
      }

      if (OrderBusinessType === 17) {
        return this.$t('IntlFlightEnquiry')
      }

      if (OrderBusinessType === 2) {
        return this.$t('DomesticHotel')
      }

      if (OrderBusinessType === 11) {
        return this.$t('IntlHotel')
      }

      if (OrderBusinessType === 10) {
        return this.$t('TrainTicket')
      }

      if (OrderBusinessType === 14) {
        return this.$t('Car')
      }
    },
  },
  components: {
    HsSectionHeader,
    HsBusinessIcon,
    HsButton
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.home-auth-list-item
  width 100%
  padding 12px 12px 16px 12px
  color $color_black_800
  box-shadow 0 0 0 0.5px $color_black_30 inset
  >.home-auth-list-item-header
    @extend .flex-between
    margin-bottom 12px
    >.name
      @extend .hs-font-subtitle-middle
      ellipsis(1)
      width 100%
      color $color_orange_300
    >.look-details
      @extend .hs-font-caption-1
      flex-shrink 0
      color $color_black_100
      margin-left 12px
  >.home-auth-list-item-cell
    @extend .flex-start
    @extend .hs-font-body
    color $color_black_800
    margin-bottom 8px
    &.last-cell
      margin-bottom 16px
    >.home-auth-list-item-cell-icon
      width 16px
      height 16px
      background-size 100% 100%
      background-repeat no-repeat
      margin-right 4px
    >.home-auth-list-cell-text
      ellipsis(1)
    >.business-item
      @extend .flex-center
      @extend .hs-font-overline-1
      padding 4px 8px
      margin-right 8px
      @media screen and (max-width: 320px)
        margin-right 0
        padding 4px 4px
      &:last-child
        margin-right 0
  >.home-auth-list-footer
    @extend .flex-between
    >.order-number
      @extend .flex-start
      @extend .hs-font-caption-1
      width 100%
      min-height 28px
      color $color_black_70
      background $color_black_10
      border-radius 4px
      margin-right 12px
      line-height normal
      >span
        ellipsis(1)
        padding-left 12px
    >.btn
      flex-shrink 0
      border-radius 4px
      padding 0 12px
      min-width 56px
</style>
